/**
 * @fileoverview GET handler for the "/email/ip_warming/:app_group_id/plan" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { emailIpWarmingAppGroupIdPlan } from "./constants";
import type { EmailIpWarmingAppGroupIdPlanResult } from "./types";
import { isEmailIpWarmingAppGroupIdPlanResult } from "./validators";

export const getEmailIpWarmingAppGroupIdPlan = reactQueryFetcherAdapter(
  emailIpWarmingAppGroupIdPlan,
  (signal: AbortSignal, appGroupId: string): Promise<EmailIpWarmingAppGroupIdPlanResult> => {
    return fetch(`/email/ip_warming/${appGroupId}/plan`, "GET", {}, { signal });
  },
  isEmailIpWarmingAppGroupIdPlanResult
);
